import React from 'react';
import Icon from '../../../components/AppIcon';

const RetentionOverviewCards = ({ data }) => {
  const cards = [
    {
      title: 'Total Members',
      value: data?.totalMembers?.toLocaleString() || '0',
      icon: 'Users',
      iconColor: 'var(--color-primary)',
      bgColor: 'bg-primary/10'
    },
    {
      title: 'Active Members',
      value: data?.activeMembers?.toLocaleString() || '0',
      icon: 'UserCheck',
      iconColor: 'var(--color-success)',
      bgColor: 'bg-success/10'
    },
    {
      title: 'At-Risk Members',
      value: data?.atRiskCount?.toLocaleString() || '0',
      icon: 'AlertTriangle',
      iconColor: 'var(--color-warning)',
      bgColor: 'bg-warning/10'
    },
    {
      title: 'Retention Rate',
      value: `${data?.retentionRate || 0}%`,
      icon: 'TrendingUp',
      iconColor: 'var(--color-accent)',
      bgColor: 'bg-accent/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {cards?.map((card, index) => (
        <div key={index} className="card hover:shadow-xl transition-all duration-250">
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <p className="text-sm text-muted-foreground mb-2">{card?.title}</p>
              <h3 className="text-3xl font-heading font-semibold text-foreground">
                {card?.value}
              </h3>
            </div>
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${card?.bgColor}`}>
              <Icon name={card?.icon} size={24} color={card?.iconColor} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RetentionOverviewCards;